import React from "react";

import Contacts from "@/pages/contacts";
import Denmarkimport from "@/pages/denmarkimport";
import Denmarkfaq from "@/pages/denmarkfaq";
function Resource() {
  return (
    <>
      <div className="relative w-full">
        <img
          src="denmarkimg.jpg" // Replace with the correct path to your image
          alt="Canada Immigrations"
          className="h-84 w-full object-cover"
        />
        <div className="absolute bottom-5 left-20 text-xl font-bold text-white drop-shadow-md md:text-4xl">
          Denmark
        </div>
      </div>
      <p className="mb-5 mt-20 text-center text-4xl font-bold text-[#011473] md:text-6xl">
        Short-Term Visa Options
      </p>

      <div className="px-8 py-12 md:py-20">
        <div className="2xl:px-52 2xl:space-y-10 space-y-10 md:grid md:grid-cols-2 md:gap-10 md:space-y-0 lg:grid lg:grid-cols-3 lg:gap-8 lg:space-y-0 lg:px-10 xl:grid xl:grid-cols-3 xl:gap-10 xl:space-y-0 xl:px-10">
          {[
            {
              href: "/resource/expert-exporter-resource-hub",
              title: "Tourist / Non-Professional Visa",
              description:
                "Allows visitors to stay in Denmark for up to 90 days for tourism purposes. Employment is not permitted under this visa category.",
              imgSrc: "/turist.jpg",
            },
            {
              href: "/resource/finding-international-distributor-guide",
              title: "Business Visa",
              description:
                "Issued for short-term business travel to Denmark, valid for stays of up to 90 days, excluding work permits.",
              imgSrc: "/bussines.jpg",
            },
            {
              href: "/resource/rules-of-origin-guide-workbook",
              title: "Denmark Visit Visa from Dubai",
              description:
                "Allows travelers to visit family or relatives in Denmark for up to 90 days.",
              imgSrc: "/visits.JPG",
            },
            {
              href: "/resource/adding-value-to-your-investments",
              title: " Visa for Medical Treatment",
              description:
                "For individuals seeking medical treatment in Denmark that is not available in their home country.",
              imgSrc: "/medical.jpg",
            },
            {
              href: "/resource/10-thing-need-about-exporting",
              title: "Denmark Student Visa",
              description:
                "For students enrolled in short-term educational programs or internships in Denmark for less than six months.",
              imgSrc: "/studentmedical.jpg",
            },
            {
              href: "/resource/7-key-changes-to-uk-eu-trade-post-brexit",
              title: "Short-Stay Visa",
              description:
                "Allows stays from 1 to 90 days and can be issued as a single, double, or multiple-entry visa, depending on eligibility.",
              imgSrc: "/stay.jpg",
            },
            {
              href: "/resource/Post-brexit-planning-checklist",
              title: "Study/ Sports/Cultural Visa",
              description:
                "For individuals participating in short-term study, sports, or cultural events for up to 90 days.",
              imgSrc: "/passports.jpg",
            },
            {
              href: "/resource/fast-track-guide-to-export-success",
              title: "Transit Visa",
              description:
                "Allows travelers passing through Denmark on their way to another destination. It is valid for stays from 1 to 90 days.",
              imgSrc: "/transit.JPG",
            },
            {
              href: "/resource/international-marketing-whitepaper",
              title: "Airport Transit Visa",
              description:
                "Required for certain nationals, this visa is for travelers with a layover in Denmark before continuing their journey.",
              imgSrc: "/air.jpg",
            },
            {
              href: "/resource/checklist-for-exporting-from-the-eu-to-the-uk-post-brexit",
              title: "Official Visit Visa",
              description:
                "Issued for individuals attending official meetings or events at the governmental or international level.",
              imgSrc: "/office.jpg",
            },
          ].map((resource, index) => (
            <div
              key={index}
              data-aos="fade-up"
              className="2xl:w-[400px] 2xl:mt-9 group relative h-auto w-80 overflow-hidden rounded-3xl border border-black font-sans hover:shadow-lg"
            >
              <a href={resource.href} className="block">
                <div className="px-2 py-2">
                  <div className="2xl:w-[380px] 2xl:h-[250px] relative h-[190px] w-[300px] overflow-hidden rounded-2xl">
                    <img
                      src={resource.imgSrc}
                      alt={resource.title}
                      className="absolute left-0 top-0 object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                  </div>
                </div>

                <div className="p-8">
                  <h3 className="font-syne mb-2 text-[20px] font-medium text-[#011473]">
                    {resource.title}
                  </h3>
                  <p className="text-sm font-medium text-black">
                    {resource.description}
                  </p>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-32 w-full px-5 md:mt-10 md:w-full md:px-10 lg:mt-20 xl:mt-20">
        <p className="mb-5 text-center text-4xl font-bold text-[#011473] md:text-6xl">
          Explore Visa Options
        </p>

        <div className="container mx-auto mb-10 mt-14">
          <div className="grid grid-cols-1 gap-6 lg:grid-cols-3 xl:grid-cols-3">
            {/* Skilled Migration Visa */}
            <div className="hover:shadow-xl group relative flex h-64 transform flex-col items-center rounded-xl border p-2 text-center shadow-md transition-transform duration-300 hover:scale-105 hover:cursor-pointer">
              <img
                src="/greencards.jpg"
                alt="Skilled Migration Visa"
                className="mb-4 h-40 w-40 transition-opacity duration-300 group-hover:opacity-0"
              />
              <h2 className="text-xl font-medium transition-opacity duration-300 group-hover:opacity-0 md:text-xl">
                Danish Green Card
              </h2>
              <div className="absolute inset-0 flex flex-col items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <p className="mb-4 text-center text-lg">
                  Denmark, known for its high quality of life, equality and
                  sustainability, is an EU and Schengen Zone member offering
                  excellent opportunities for skilled professionals.
                </p>
                <a href="/denmark-danish-greencard">
                  <button className="rounded-lg bg-blue-500 px-4 py-2 text-white transition-colors duration-300 hover:bg-blue-600">
                    Read More
                  </button>
                </a>
              </div>
            </div>

            {/* Investor Visa */}

            {/* Student Visa */}
            <div className="hover:shadow-xl group relative flex h-64 transform flex-col items-center rounded-xl border p-8 text-center shadow-md transition-transform duration-300 hover:scale-105 hover:cursor-pointer">
              <img
                src="/student.jpg"
                alt="Student Visa"
                className="mb-4 h-40 w-40 transition-opacity duration-300 group-hover:opacity-0"
              />
              <h2 className="text-xl font-medium transition-opacity duration-300 group-hover:opacity-0 md:text-xl">
                Student Visa
              </h2>
              <div className="absolute inset-0 flex flex-col items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <p className="mb-4 text-center text-lg">
                  Denmark is a top destination for international students,
                  offering world-className education and a thriving economy,
                  making it ideal for academic
                </p>
                <a href="/denmark-student-visa">
                  <button className="rounded-lg bg-blue-500 px-4 py-2 text-white transition-colors duration-300 hover:bg-blue-600">
                    Read More
                  </button>
                </a>
              </div>
            </div>

            {/* Visit Visa */}
            <div className="hover:shadow-xl group relative flex h-64 transform flex-col items-center rounded-xl border p-2 text-center shadow-md transition-transform duration-300 hover:scale-105 hover:cursor-pointer">
              <img
                src="/visit.jpg"
                alt="Visit Visa"
                className="mb-4 h-40 w-40 transition-opacity duration-300 group-hover:opacity-0"
              />
              <h2 className="text-xl font-medium transition-opacity duration-300 group-hover:opacity-0 md:text-xl">
                Visit Visa
              </h2>
              <div className="absolute inset-0 flex flex-col items-center justify-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <p className="mb-4 text-center text-lg">
                  A Danish visit visa permits short stays of up to 3 months,
                  granting easy access to Denmark and the rest of the Schengen
                  Area.
                </p>
                <a href="/denmark-visit-visa">
                  <button className="rounded-lg bg-blue-500 px-4 py-2 text-white transition-colors duration-300 hover:bg-blue-600">
                    Read More
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Denmarkimport />
      <Denmarkfaq />
      <Contacts />
    </>
  );
}

export default Resource;
